// ── App Preview (in-dashboard TV frame over /app/v1) ──
//
// D-2.6 transport: the preview fetches the PUBLIC /app/v1 contract directly
// from the platform content host, resolving tenancy with the same
// x-app-customer-domain header the Roku shell itself sends (SHApiBase +
// SHAppDomain). The content host serves /app/v1 with permissive CORS, so no
// dashboard-side proxy exists — keep it that way.

export const APP_PREVIEW_CONTENT_HOSTS = {
  streamhoster: 'https://c.streamhoster.com',
  whitelabel: 'https://c.themediacdn.com',
} as const;

export const APP_PREVIEW_TENANT_HEADER = 'x-app-customer-domain';

/**
 * Default platform param for preview fetches. Since 3.34.0 each TV tab passes
 * its own (`roku`, `firetv`): the home-screen layout the preview draws is the
 * shared one, but the cfg payload's platform block is the tab's.
 */
export const APP_PREVIEW_PLATFORM = 'roku';

export const APP_PREVIEW_QUERY_KEYS = {
  all: ['appPreview'] as const,
  cfg: (domain: string, platform: string) =>
    [...APP_PREVIEW_QUERY_KEYS.all, 'cfg', domain, platform] as const,
  browse: (domain: string, platform: string) =>
    [...APP_PREVIEW_QUERY_KEYS.all, 'browse', domain, platform] as const,
  /** The app's legacy Roku JSON feed (the deep-link derive's source), keyed by its URL. */
  rokuFeed: (feedUrl: string) => [...APP_PREVIEW_QUERY_KEYS.all, 'rokuFeed', feedUrl] as const,
} as const;

// ── Home layouts (design ADR-0015; ott/design system/surfaces.md "Layouts") ──
//
// The server decides the layout from the catalog and emits it on the browse
// payload; the preview renders it like the shells do. Absent or unknown = rails.

export const HOME_LAYOUT = {
  EMPTY: 'empty',
  BILLBOARD: 'billboard',
  ONE_SCREEN: 'one_screen',
  RAILS: 'rails',
} as const;
export type HomeLayout = typeof HOME_LAYOUT[keyof typeof HOME_LAYOUT];

/** The empty home's line (the shells' and the Web App's wording). */
export const HOME_EMPTY_LINE = 'Nothing published yet';

/** Under the TV preview and on the General tab (ADR-0015 "Dashboard copy"). */
export const HOME_ADAPTS_HELP =
  'Your TV home screen adapts to how much you publish: one video or live stream fills the screen; one row of videos stays on one screen; more rows scroll.';

/**
 * The static host that serves an app's stored images by object key
 * (`appCfg.core.homeBgKey`), brand-matched like the content hosts above.
 */
export const APP_STATIC_HOSTS = {
  streamhoster: 'https://static.streamhoster.com',
  whitelabel: 'https://static.themediacdn.com',
} as const;
